var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
var cls = classNames('entity-content-embed');
// import 'react-medium-image-zoom/dist/styles.css';
import { get } from 'lodash';
import { classNames } from '@shapeable/utils';
import { EntityBubbleImage } from '../entities/entity-bubble-image';
import { CellLabel } from './cell-label';
import { useLink } from '../hooks/use-link';
import { ArrowRightIcon } from '@shapeable/icons';
export var EntityContentEmbedDefaultProps = {
  imageSize: 68,
  showDescription: true
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: flex-start;\n    gap: ", ";\n    border-radius: ", ";\n    box-shadow: 4px 4px 16px 0px ", ";\n\n    &:hover {\n      box-shadow: 8px 8px 20px 0px ", ";\n      ", ";\n    }\n  "], ["\n    display: flex;\n    align-items: flex-start;\n    gap: ", ";\n    border-radius: ", ";\n    box-shadow: 4px 4px 16px 0px ", ";\n\n    &:hover {\n      box-shadow: 8px 8px 20px 0px ", ";\n      ", ";\n    }\n  "])), theme.UNIT(3), theme.UNIT(2), theme.COLOR('app-chrome'), theme.COLOR('app-chrome'), theme.TRANSITION('box-shadow')),
  tablet: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ImgStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    flex-shrink: 0;\n    padding: ", ";\n    background: ", ";\n    border-radius: ", " 0 0 ", ";\n  "], ["\n    flex-shrink: 0;\n    padding: ", ";\n    background: ", ";\n    border-radius: ", " 0 0 ", ";\n  "])), theme.UNIT(5), theme.COLOR('app-chrome'), theme.UNIT(2), theme.UNIT(2))
});
var BodyStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    padding: ", " ", " ", " 0;\n    border-radius: 0 ", " ", " 0;\n  "], ["\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    padding: ", " ", " ", " 0;\n    border-radius: 0 ", " ", " 0;\n  "])), theme.UNIT(2), theme.UNIT(2), theme.UNIT(2), theme.UNIT(2), theme.UNIT(2))
});
var LabelAndIconStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    justify-content: space-between;\n  "], ["\n    display: flex;\n    justify-content: space-between;\n  "])))
});
var LabelStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    margin: 0;\n    font-weight: 300;\n    font-size: 0.7em !important;\n    color: ", " !important;\n  "], ["\n    margin: 0;\n    font-weight: 300;\n    font-size: 0.7em !important;\n    color: ", " !important;\n  "])), theme.COLOR('text'))
});
var TitleStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), theme.MAX_LINES(1))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Image: styled(EntityBubbleImage)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ImgStyles),
  Body: styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  LabalAndIcon: styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), LabelAndIconStyles),
  Label: styled(CellLabel)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Title: styled.span(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles)
};
export var EntityContentEmbed = function (props) {
  var className = props.className,
    entity = props.entity,
    rest = __rest(props, ["className", "entity"]);
  var name = entity.name,
    _label = entity._label;
  var hasLabel = !!_label;
  var hasName = !!name;
  var Link = useLink().Link;
  var linkStyle = {
    textDecoration: 'none',
    color: get(theme, 'color.text', '#000')
  };
  return React.createElement(Link, {
    href: entity.url,
    style: linkStyle
  }, React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Image, {
    entity: entity,
    size: 60
  }), React.createElement(My.Body, null, React.createElement(My.LabalAndIcon, null, hasLabel && React.createElement(My.Label, {
    tag: 'h6'
  }, _label), React.createElement(ArrowRightIcon, {
    size: 16,
    colors: {
      fill: 'text'
    }
  })), hasName && React.createElement(My.Title, null, name))));
};
EntityContentEmbed.defaultProps = EntityContentEmbedDefaultProps;
EntityContentEmbed.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;